import LazyImage from "@/components/ui/lazy-image";
import profileImage from "@/assets/profile.jpg";

interface ProfileImageProps {
  parallaxOffset: number;
}

const ProfileImage = ({ parallaxOffset }: ProfileImageProps) => {
  // Cache-bust to avoid PWA/image-cache serving an older profile picture.
  const profileSrc = `${profileImage}?v=2026-01-29`;

  return (
    <div 
      className="relative group flex-shrink-0"
      style={{ transform: `translateY(${parallaxOffset}px)` }}
    >
      {/* Outer glow ring */}
      <div className="absolute -inset-2 sm:-inset-3 rounded-full bg-gradient-to-br from-primary/20 via-primary/5 to-transparent opacity-0 group-hover:opacity-100 blur-xl transition-all duration-700" />
      
      {/* Decorative ring */}
      <div className="absolute -inset-1 sm:-inset-1.5 rounded-full border border-primary/20 group-hover:border-primary/40 group-hover:scale-105 transition-all duration-700" />
      
      {/* Main image container */}
      <div className="relative w-40 h-40 sm:w-48 sm:h-48 md:w-64 md:h-64 lg:w-72 lg:h-72 rounded-full overflow-hidden border-2 border-primary/30 shadow-luxury-lg transition-all duration-700 group-hover:border-primary/50 group-hover:shadow-glow">
        <LazyImage
          src={profileSrc}
          alt="Aurélia Ravelo - Chef de Projet Digital"
          width={288}
          height={288}
          className="w-full h-full object-cover rounded-full"
          priority={true}
        />
        {/* Subtle overlay on hover */}
        <div className="absolute inset-0 bg-gradient-to-t from-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
      </div>
    </div>
  );
};

export default ProfileImage;
